import { z, ZodType } from 'zod';
import { Validation } from '@mews/framework';
import {
    PosMicrosIntegrationExternalPaymentTypes,
    PosMicrosIntegrationPaymentMapping,
} from '@mews-commander/data-access';
import { FieldNames } from '../fieldNames';

export const paymentMappingFormSchema = z.object({
    [FieldNames.paymentNumber]: Validation.String.Required,
    [FieldNames.paymasterId]: z.string().default(''),
    [FieldNames.accountingCategoryId]: Validation.String.Required.uuid(),
    [FieldNames.externalPaymentType]: z.nativeEnum(PosMicrosIntegrationExternalPaymentTypes),
    [FieldNames.isDefault]: z.boolean().default(false),
}) satisfies ZodType<PosMicrosIntegrationPaymentMapping>;
